module.exports = __webpack_public_path__ + "static/media/pagos.07d18c75.svg";